// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"17":"239dc750","55":"658bb631","188":"9ec05cfd","241":"fc75a519","270":"bb0466bc","453":"f31200d3","506":"6f5c2d02","508":"6051aae0","622":"a9ef9a3e","668":"3ccbdb70","820":"6f9298b4","896":"7becbf5c"}[chunkId] + ".chunk.js";
};